
import Products from '../components/Products';
import Services from '../components/Features';
import Pricing from '../components/SubscriptionPlans';
import About1 from '../components/About1';
import Contact from '../components/Contact';
import About from '../components/About';
import Features from '../components/Features';
import SubscriptionPlans from '../components/SubscriptionPlans';


const Home = (): JSX.Element => {
 

  return (
    <div>
      
      <div id='home'>
        <About />
        {/* <Products /> */}
        <Features />
        <SubscriptionPlans />
        {/* <About />  */}
        <Contact/>
      </div>
    </div>
  );
};

export default Home;
